import "../styles/Contact.css";
import React from "react";

import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaClock,
  FaArrowRight,
} from "react-icons/fa";

const Contact = () => {
  return (
    <section className="contact" id="contact">

      <div className="contact-heading">

        <span>CONTACT US</span>

        <h2>Let's Build Your Smart Fuel Station</h2>

        <p>
          Since 1994, ITWORLD has been delivering reliable software and
          automation solutions for fuel stations across Pakistan.
          Contact us today for a free consultation or product demonstration.
        </p>

      </div>

      <div className="contact-wrapper">

        {/* Left */}

        <div className="contact-info">

          <div className="since-box">

            <h3>Since 1994</h3>

            <p>Serving Fuel Stations Across Pakistan</p>

          </div>

          <div className="info-card">

            <FaPhoneAlt />

            <div>

              <h4>Call Us</h4>

              <p>0303-9692162</p>

              <p>0300-4170612</p>

            </div>

          </div>

          <div className="info-card">

            <FaEnvelope />

            <div>

              <h4>Email</h4>

              <p>itworldmanagement@gmail.com</p>

            </div>

          </div>

          <div className="info-card">

            <FaMapMarkerAlt />

            <div>

              <h4>Office</h4>

              <p>
                Second Floor,
                <br />
                18 Sunny Park,
                <br />
                Lahore
              </p>

            </div>

          </div>

          <div className="info-card">

            <FaClock />

            <div>

              <h4>Working Hours</h4>

              <p>Monday - Saturday</p>

              <p>09:00 AM - 06:00 PM</p>

              <p>24/7 Technical Support</p>

            </div>

          </div>

        </div>

        {/* Right */}

        <div className="contact-form">

          <h3>Request Free Demo</h3>

          <form>

            <input
              type="text"
              placeholder="Full Name"
            />

            <input
              type="text"
              placeholder="Phone Number"
            />

            <input
              type="email"
              placeholder="Email Address"
            />

            <input
              type="text"
              placeholder="Company / Fuel Station Name"
            />

            <select>

              <option>Select Solution</option>

              <option>Accounts ERP</option>

              <option>Nozzle Automation</option>

              <option>Fuel Receipt Printing</option>

              <option>External Display</option>

              <option>Complete Package</option>

            </select>

            <textarea
              rows="5"
              placeholder="Tell us about your fuel station and the solution you're interested in..."
            ></textarea>

            <button type="submit">

              Request Free Demo

              <FaArrowRight />

            </button>

          </form>

        </div>

      </div>

    </section>
  );
};

export default Contact;